import { Link } from "react-router-dom";

export function SiteFooter() {
  return (
    <footer className="mt-7 text-[0.70rem] tracking-[0.1em] text-[rgba(31,29,25,0.62)] flex items-center gap-3">
      <span>© {new Date().getFullYear()}</span>
      <span>·</span>
      <Link viewTransition to="/imprint" className="hover:text-[rgba(31,29,25,0.9)] transition-colors">
        Imprint
      </Link>
      <span>·</span>
      <Link viewTransition to="/privacy" className="hover:text-[rgba(31,29,25,0.9)] transition-colors">
        Privacy
      </Link>
    </footer>
  );
}
